import React, { FC, useState, useEffect } from 'react';
import { Modal, Form, Input, Checkbox } from 'antd';
import styles from '../../Annotation.module.scss';
import { DataQCAssessment } from './qc.slice';

type Props = {
  showModal: boolean;
  dataQCAssessment: DataQCAssessment | null;
  isLoading: boolean;
  closeModal: () => void;
  onSave: (qcIssuesForTurbine: boolean, comment: string, contrastIssue: boolean, blurIssue: boolean) => void;
  isTurbineQC: boolean;
};

const DataQCAssessmentModal: FC<Props> = ({ showModal, dataQCAssessment, isLoading, closeModal, onSave, isTurbineQC }) => {
  const [qcIssuesForTurbine, setQcIssuesForTurbine] = useState(false);
  const [comment, setComment] = useState('');
  const [contrastIssue, setContrastIssue] = useState(false);
  const [blurIssue, setBlurIssue] = useState(false);

  useEffect(() => {
    if (showModal && dataQCAssessment) {
      setQcIssuesForTurbine(dataQCAssessment.haveQC);
      setComment(dataQCAssessment.comment);
      setContrastIssue(dataQCAssessment.hasContrastIssues);
      setBlurIssue(dataQCAssessment.isBlurred);
    }

    if (showModal && !dataQCAssessment) {
      setQcIssuesForTurbine(false);
      setContrastIssue(false);
      setBlurIssue(false);
      setComment('');
    }
  }, [showModal, dataQCAssessment]);

  return (
    <Modal
      title='Data QC assessment'
      wrapClassName={'data-qa-assessment-modal'}
      className='modal-container'
      visible={showModal}
      okText='Save'
      okButtonProps={{ disabled: !(comment && comment.length), loading: isLoading }}
      onOk={() => onSave(qcIssuesForTurbine, comment, contrastIssue, blurIssue)}
      onCancel={closeModal}
    >
      <Form>
        <Form.Item className={styles.antFormItem}>
          <Checkbox checked={qcIssuesForTurbine} onChange={e => setQcIssuesForTurbine(e.target.checked)}>
            QC issues
          </Checkbox>
        </Form.Item>

        {!isTurbineQC && (
          <>
            <Form.Item className={styles.antFormItem}>
              <Checkbox disabled={!qcIssuesForTurbine} checked={contrastIssue} onChange={e => setContrastIssue(e.target.checked)}>
                Contrast issues
              </Checkbox>
            </Form.Item>
            <Form.Item className={styles.antFormItem}>
              <Checkbox disabled={!qcIssuesForTurbine} checked={blurIssue} onChange={e => setBlurIssue(e.target.checked)}>
                Blurred
              </Checkbox>
            </Form.Item>
          </>
        )}

        <Form.Item label='Comment' className={styles.antFormItem} required>
          <Input disabled={!qcIssuesForTurbine} placeholder='Comment' value={comment} onChange={e => setComment(e.target.value)} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DataQCAssessmentModal;
